import { useState, useCallback } from "react";
import { apiClient } from "@/lib/api-client.js";

export interface PvgisMonthlyData {
  month: number;
  emonth: number;
  hHorizMonth: number;
  hInclinedMonth: number;
}

export interface PvgisResult {
  annualYieldKwh: number;
  annualIrradianceKwhM2: number;
  optimalTiltDeg: number;
  optimalAzimuthDeg: number;
  systemLossPercent: number;
  monthly: PvgisMonthlyData[];
  source: "pvgis" | "unavailable";
  raddatabase: string;
  /** Bei source:"unavailable" gesetzt; die numerischen Felder sind dann 0 (keine Ertragswerte). */
  warning?: string;
}

export function usePvgis() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<PvgisResult | null>(null);

  const fetchPvgisData = useCallback(
    async (
      lat: number,
      lng: number,
      tilt?: number,
      azimuth?: number,
    ): Promise<PvgisResult | null> => {
      setLoading(true);
      const params = new URLSearchParams({
        lat: lat.toString(),
        lng: lng.toString(),
      });
      if (tilt !== undefined) params.set("tilt", tilt.toString());
      if (azimuth !== undefined) params.set("azimuth", azimuth.toString());
      const res = await apiClient.get<PvgisResult>(`/geo/pvgis?${params.toString()}`);
      setLoading(false);
      if (res.success) {
        setData(res.data);
        return res.data;
      }
      return null;
    },
    [],
  );

  return { fetchPvgis: fetchPvgisData, pvgisData: data, pvgisLoading: loading };
}
